<div class="table-section">
  <lx-price-lists-portal-table-header title="Package prices" [currency]="currency"></lx-price-lists-portal-table-header>
  <lx-price-lists-portal-course-table [data]="data" [columnLabels]="columnLabels" [company]="company"></lx-price-lists-portal-course-table>
  <lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [company]="company"></lx-price-lists-portal-notes>
</div>
